export default function ($httpProvider) {
    // NOTE: first defined interceptors will be called last
    $httpProvider.interceptors.push(authorizationInterceptor);
    $httpProvider.interceptors.push(httpErrorInterceptor);
    $httpProvider.interceptors.push(validationErrorInterceptor);
}

// @ngInject
function authorizationInterceptor(authorizationToken) {
    return {
        request(config) {
            config.headers.Authorization = `Bearer ${ authorizationToken }`;
            return config;
        }
    };
}

function checkIfIpRestricted() {
    return fetch('/api/health', {
        credentials: 'same-origin',
        method: 'GET'
    })
    .then(response => {
        return response.status === 403;
    })
    .catch(() => {
        // If fetch fails, assume not IP restricted to allow normal flow
        return false;
    });
}

// @ngInject
function httpErrorInterceptor(toaster, $q) {
    return {
        responseError(res) {
            if (res.status === 401) {
                const redirectToLogin = localStorage.getItem('redirectToLogin');

                if (!redirectToLogin) {
                    localStorage.removeItem('token');
                    localStorage.setItem('redirectToLogin', 'redirectToLogin');

                    // HACK: we can't use $http here as it will cause a circular dependency
                    checkIfIpRestricted().then(isBlocked => {
                        if (isBlocked) {
                            localStorage.removeItem('redirectToLogin');
                            window.location.replace('/#/noaccess');
                        } else {
                            fetch(encodeURI('/sts/connect/endsession?post_logout_uri=/'), {
                                credentials: 'same-origin'
                            })
                            .then(() => {
                                window.location = '/';
                            });
                        }
                    })
                    .then(() => {
                        $q.reject(res);
                    });
                } else {
                    return $q.reject(res);
                }
            }
            if (res.status === 403) {
                localStorage.removeItem('redirectToLogin');
                window.location.replace('/#/noaccess');
                return $q.reject(res);
            }

            if ((res.status === 404 || res.status === 400) && res.data.Message) {
                toaster.error(res.data.Message);
            }

            throw res;
        }
    };
}

// @ngInject
function validationErrorInterceptor(toaster) {
    return {
        responseError(res) {
            if (res.data && Array.isArray(res.data.validationErrors)) {
                res.data.validationErrors.forEach(e => {
                    if (typeof e === 'string') {
                        toaster.error(e);
                    }

                    toaster.error(`${ e.propertyName }: ${ e.errorMessage }`);
                });
            }

            throw res;
        }
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/config/httpInterceptor.js